import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';
import igLogo from '../assets/ig-logo.png';

const Footer = () => {
  return (
    <footer className="footer py-4">
      <Container>
        <div className="footer-divider mb-4"></div>
        <Row className="align-items-center">
          <Col xs={6} className="text-start">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
              className="d-flex align-items-center"
            >
              <a 
                href="https://www.instagram.com/jgwineclub/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="d-flex align-items-center text-decoration-none"
              >
                <img 
                  src={igLogo} 
                  alt="Instagram" 
                  className="ig-logo me-2" 
                />
                <span className="text-white">jgwineclub</span>
              </a>
            </motion.div>
          </Col>
          <Col xs={6} className="text-end">
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="mb-0 text-white"
            >
              Somos tu club de vinos
            </motion.p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer; 